/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type DashboardDropDown_sales = {
    readonly isNull: boolean;
    readonly name: string;
    readonly key: string;
    readonly yesterdaysSalesToDate: number;
    readonly currentMonthToDate: number;
    readonly lastMonthMonthToDate: number;
    readonly lastMonth: number;
    readonly " $refType": "DashboardDropDown_sales";
};
export type DashboardDropDown_sales$data = DashboardDropDown_sales;
export type DashboardDropDown_sales$key = {
    readonly " $data"?: DashboardDropDown_sales$data;
    readonly " $fragmentRefs": FragmentRefs<"DashboardDropDown_sales">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DashboardDropDown_sales",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isNull",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "yesterdaysSalesToDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentMonthToDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastMonthMonthToDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastMonth",
      "storageKey": null
    }
  ],
  "type": "DetailedSalesReportSales",
  "abstractKey": null
};
(node as any).hash = '71697e9fe50b214052ddfef14ea5cddd';
export default node;
